import { c as _c } from "react/compiler-runtime";
import type { CollectDataNodeProps } from '../../playbook-builder.types';
import InformationSection from '../identity-data-node/components/information-section';
import ResidencyView from '../identity-data-node/components/residency-view';
import InvestorProfileSection from '../investor-profile-section';
import CustomRequirementsSection from './components/person/custom-requirements-section';
export type PersonDataProps = {
  node: CollectDataNodeProps;
};
const PersonData = t0 => {
  const $ = _c(12);
  const {
    node
  } = t0;
  let t1;
  let t2;
  if ($[0] !== node) {
    t1 = <InformationSection node={node} />;
    t2 = <ResidencyView node={node} />;
    $[0] = node;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== node.data.mustCollectData) {
    t3 = node.data.mustCollectData.includes("investor_profile") ? <InvestorProfileSection /> : null;
    $[3] = node.data.mustCollectData;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== node) {
    t4 = node.data.customRequirements.length ? <CustomRequirementsSection node={node} /> : null;
    $[5] = node;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = <div className="flex flex-col gap-4 pb-4">{t1}{t2}{t3}{t4}</div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export default PersonData;